import React from 'react';
// components
import Loading from '../../../../../../components/Loading';
// assets
import * as S from '../styles';

const ModalLoader = () => (
  <S.Modal noBackground>
    <Loading size={45} />
  </S.Modal>
);

export default ModalLoader;
